import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addEventUserGeneralSetting, fetchEventSettingMarketEvents, fetchEventUserGeneralSetting, fetchUserGeneralSetting } from 'services/event-user-general-setting';

export const fetchEventUserGeneralSettingAsync = createAsyncThunk(
    'eventUserGeneralSetting/fetchEventUserGeneralSetting',
    async (data, { rejectWithValue }) => {
        try {
            const response = await fetchEventUserGeneralSetting(data);
            return response.resultData;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch event user general setting');
        }
    }
)

export const fetchEventSettingMarketEventsAsync = createAsyncThunk(
    'eventUserGeneralSetting/fetchEventSettingMarketEvents',
    async (data, { rejectWithValue }) => {
        try {
            const response = await fetchEventSettingMarketEvents(data);
            return response.resultData;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch event setting market events');
        }
    }
)
export const fetchUserGeneralSettingAsync = createAsyncThunk(
    'eventUserGeneralSetting/fetchUserGeneralSetting',
    async (data, { rejectWithValue }) => {
        try {
            const response = await fetchUserGeneralSetting(data);
            return response.resultData;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch user general setting');
        }
    }
)
export const addEventUserGeneralSettingAsync = createAsyncThunk(
    'eventUserGeneralSetting/addEventUserGeneralSetting',
    async (data, { rejectWithValue }) => {
        try {
            const response = await addEventUserGeneralSetting(data);
            return response.resultData;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to add event user general setting');
        }
    }
)
const eventUserGeneralSettingSlice = createSlice({
    name: 'eventUserGeneralSetting',
    initialState: {
        eventUserGeneralSetting: [],
        eventSettingMarketEvents: [],
        userGeneralSetting: [],
        loading: false,
        error: null
    },
    reducers: {
        clearUserGeneralSetting(state) {
            state.eventUserGeneralSetting = [];
            state.eventSettingMarketEvents = [];
            state.userGeneralSetting = [];
            state.loading = false;
            state.error = null;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEventUserGeneralSettingAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEventUserGeneralSettingAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.eventUserGeneralSetting = action.payload;
                state.error = null;
            })
            .addCase(fetchEventUserGeneralSettingAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchEventSettingMarketEventsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEventSettingMarketEventsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.eventSettingMarketEvents = action.payload;
                state.error = null;
            })
            .addCase(fetchEventSettingMarketEventsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchUserGeneralSettingAsync.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserGeneralSettingAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.userGeneralSetting = action.payload;
                state.error = null;
            })
            .addCase(fetchUserGeneralSettingAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addEventUserGeneralSettingAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addEventUserGeneralSettingAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.eventUserGeneralSetting = action.payload;
                state.error = null;
            })
            .addCase(addEventUserGeneralSettingAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { } = eventUserGeneralSettingSlice.actions;

export default eventUserGeneralSettingSlice.reducer;